import React, { Component } from 'react';
import packageInfo from '../../package.json';    
import { INK_TOOLING_MEDIA_URL } from '../components/homepage/utils/constants';
import styled from 'styled-components';

const FooterContainer = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  padding: 8px;
  margin-bottom: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};

  .footer-text {
    font-size: 10px;
    font-weight: 400;
    line-height: 10px;
    color: ${({ theme }) => theme.colors.gullGrey};
  }
`;

class Footer extends Component {
  render() {
    const version = packageInfo.version;
    return (
      <FooterContainer>
        <img width="48px" height="43px" src={`${INK_TOOLING_MEDIA_URL}/ink-logo.svg`} alt="Ink" />
        <div className="ml-3 footer-text">Ink. v{version} © Copyright {new Date().getFullYear()}, The Philadelphia Inquirer, PBC</div>
      </FooterContainer>
    );
  }
}

export default Footer;
